import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import TransferDialog from './TransferDialog.vue';
import { changePaperStatus, copyPaper, getPaperList, transferPaper } from "@/api/test-paper";
let ListTable = class ListTable extends Vue {
    constructor() {
        super(...arguments);
        this.pageIndex = 1;
        this.pageSize = 15;
        this.totalCount = 0;
        this.tableData = [];
        this.hasShowTreeModal = false;
        this.selectedRows = [];
        this.btnLoading = false;
        this.currentOperateRow = {};
        this.currentOperate = '';
        this.toLibraryId = '';
        this.toParentId = '0';
        this.isPageInit = false;
        this.selectCheck = false;
        this.isIndeterminate = false;
    }
    get selectedRowsPos() {
        return this.selectedRows.reduce((acc, cur, idx) => {
            acc[cur.id] = idx;
            return acc;
        }, {});
    }
    get selectedRowsId() {
        return this.selectedRows.map((val) => {
            return val.id;
        });
    }
    get currentPageSelectedRows() {
        const selected = this.selectedRowsId;
        return this.tableData.filter((val) => {
            return selected.indexOf(val.id) > -1;
        });
    }
    get fakeTreeData() {
        return this.treeData.length > 0 && this.treeData[0].children || [];
    }
    get operateTitle() {
        var _map = {
            move: "转移",
            batchMove: "批量转移",
            copy: "复制"
        };
        return _map[this.currentOperate] || "";
    }
    get curSelectedRows() {
        return this.selectedRows.length > 0 ? `（${this.selectedRows.length}）` : "";
    }
    handleLibraryIdChange(id) {
        if (!id)
            return;
        if (this.isPageInit) {
            this.pageIndex = 1;
        }
        else {
            this.pageIndex = Number(sessionStorage.getItem("paperPageIndex")) || 1;
            this.isPageInit = true;
        }
        // console.log("this.pageIndex", this.pageIndex)
        sessionStorage.setItem("paperPageIndex", `${this.pageIndex}`);
        this.updateListData();
    }
    handleSelectedRowsChange() {
        this.selectCheck = this.currentPageSelectedRows.length === this.tableData.length;
        this.isIndeterminate = !this.selectCheck && 0 !== this.currentPageSelectedRows.length;
    }
    handleCurrentChange(pageIndex) {
        this.pageIndex = pageIndex;
        sessionStorage.setItem("paperPageIndex", `${pageIndex}`);
        this.updateListData();
    }
    async updateListData() {
        const params = {
            categoryId: this.libraryId !== '0' ? this.libraryId : void 0,
            content: this.keyword ? this.keyword : void 0,
            pageNo: this.pageIndex,
            pageSize: this.pageSize
        };
        // this.$store.commit("setGlobalLoading", true)
        try {
            const res = await getPaperList(params);
            const data = res.data.data;
            this.totalCount = Number(data.total);
            this.tableData = data.list || [];
            if (this.currentPageSelectedRows.length > 0) {
                this.$nextTick(() => {
                    const tableEl = this.table;
                    if (tableEl) {
                        // var data = e.getTable();
                        this.currentPageSelectedRows.forEach((e) => {
                            tableEl.toggleRowSelection(e, true);
                        });
                    }
                    const length = this.currentPageSelectedRows.length;
                    this.selectCheck = length === this.tableData.length;
                    this.isIndeterminate = !this.selectCheck && 0 !== length;
                });
            }
        }
        catch (error) {
            console.error(error);
            this.tableData = [];
            this.pageIndex = 1;
            sessionStorage.setItem("paperPageIndex", '1');
            this.totalCount = 0;
        }
        finally {
            // this.$store.commit("setGlobalLoading", false);
        }
    }
    handleSelect(_, row) {
        if (this.selectedRowsId.indexOf(row.id) > -1) {
            var index = this.selectedRowsPos[row.id];
            this.selectedRows.splice(index, 1);
        }
        else {
            this.selectedRows.push(row);
        }
    }
    handleSelectAll(selection) {
        const length = selection.length;
        if (length > 0) {
            const unselectedRows = selection.filter(row => -1 === this.selectedRowsId.indexOf(row.id));
            this.selectedRows = this.selectedRows.concat(unselectedRows);
        }
        else {
            const selectedRowsId = this.currentPageSelectedRows.map(row => row.id);
            selectedRowsId.forEach((id) => {
                const index = this.selectedRowsPos[id];
                this.selectedRows.splice(index, 1);
            });
        }
    }
    jumpToPreview(paper) {
        const route = this.$router.resolve({
            name: "TestPaperPreview",
            query: {
                paper_id: paper.id
            }
        });
        window.open(route.href, "_blank");
    }
    editQuestion(paper) {
        sessionStorage.setItem('examination_depot_library_id', this.libraryId);
        this.$router.push({
            name: "TestPaperEdit",
            query: {
                step: '1',
                paper_id: paper.id
            }
        });
    }
    handleOperateQuesPre(command, paper) {
        this.currentOperate = command;
        const isBatch = command.includes("batch"), isDeactivate = command.toLowerCase().includes("deactivate"), isActivate = command.toLowerCase().includes("activate");
        if (isBatch && 0 === this.selectedRows.length) {
            this.$message.warning("请选择试卷！");
        }
        else {
            this.currentOperateRow = paper || null;
            if (isDeactivate) {
                const hasRelated = this.currentOperateRow.referenceCount > 0;
                if (hasRelated) {
                    this.$alert('该试卷已被引用，如需停用，请先解除关系', '停用提示', {
                        type: "info",
                        confirmButtonText: '知道了',
                        showCancelButton: false,
                    });
                }
                else {
                    this.$confirm('停用试卷不会删除题库中的题目。', {
                        type: 'error',
                        title: '确定停用该试卷吗？',
                        confirmButtonText: '停用',
                        cancelButtonText: '我再想想'
                    }).then(this.handleDeactivate);
                }
            }
            else if (isActivate) {
                this.$confirm('请谨慎操作。', {
                    type: 'error',
                    title: '确定启用该试卷吗？',
                    confirmButtonText: '启用',
                    cancelButtonText: '我再想想'
                }).then(this.handleActivate);
            }
            else {
                this.hasShowTreeModal = true;
            }
        }
    }
    handleOperateQues() {
        const handlers = {
            move: this.handleMove,
            batchMove: this.handleMove,
            copy: this.handleCopy
        };
        const command = this.currentOperate.toLowerCase();
        const isCopy = command.includes("copy");
        const isMove = command.includes("move");
        const isBatch = command.includes("batch");
        const handler = handlers[this.currentOperate];
        const data = {
            idList: isBatch ? this.selectedRowsId : [this.currentOperateRow.id]
        };
        if (isMove || isCopy) {
            data.LibraryId = this.toLibraryId;
        }
        handler && handler(data);
    }
    async handleMove(data) {
        const { idList, LibraryId } = data;
        try {
            await transferPaper(idList, LibraryId);
            this.selectedRows = [];
            sessionStorage.setItem('examination_depot_library_id', this.toLibraryId);
            this.$message.success("试卷转移成功");
            this.hasShowTreeModal = false;
            this.$emit("refresh-tree");
        }
        catch (_) { }
    }
    async handleActivate() {
        const idList = [this.currentOperateRow.id];
        try {
            await changePaperStatus(idList, 1);
            this.selectedRows = [];
            this.$message.success("试卷启用成功");
            this.updateListData();
        }
        catch (_) { }
    }
    async handleDeactivate() {
        const idList = [this.currentOperateRow.id];
        try {
            await changePaperStatus(idList, 0);
            this.selectedRows = [];
            this.$message.success("试卷停用成功");
            this.updateListData();
            // this.$emit("refresh-tree")
        }
        catch (_) { }
    }
    handleTreeNodeClick(data) {
        this.toParentId = data.parentId;
        this.toLibraryId = data.id;
    }
    async handleCopy(data) {
        const { idList, LibraryId } = data;
        try {
            await copyPaper(idList, LibraryId);
            this.$message.success("试卷复制成功");
            this.hasShowTreeModal = false;
            this.updateListData();
            this.$emit("refresh-tree");
        }
        catch (_) { }
    }
    selectBox(checked) {
        const tableData = checked ? this.tableData : [];
        this.handleSelectAll(tableData);
        if (!tableData.length)
            this.selectCheck = false;
        const tableEl = this.table;
        if (checked) {
            tableData.forEach((row) => {
                tableEl.toggleRowSelection(row, true);
            });
        }
        else {
            tableEl.clearSelection();
        }
        this.isIndeterminate = false;
    }
    sizeChange(pageSize) {
        this.pageSize = pageSize;
        this.pageIndex = 1;
        this.updateListData();
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ListTable.prototype, "libraryId", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ListTable.prototype, "keyword", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], ListTable.prototype, "treeData", void 0);
tslib_1.__decorate([
    Prop({ type: Number, default: 0 })
], ListTable.prototype, "maxHeight", void 0);
tslib_1.__decorate([
    Ref()
], ListTable.prototype, "table", void 0);
tslib_1.__decorate([
    Watch('libraryId', { immediate: true })
], ListTable.prototype, "handleLibraryIdChange", null);
tslib_1.__decorate([
    Watch('selectedRows')
], ListTable.prototype, "handleSelectedRowsChange", null);
ListTable = tslib_1.__decorate([
    Component({
        name: 'ListTable',
        components: {
            TransferDialog
        },
    })
], ListTable);
export default ListTable;
